import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, formatApiErrorDetail } from "@/api/client";
import { toast } from "sonner";

const propertyTypes = ["Apartamento", "Moradia", "Terreno", "Loja/Comercial", "Outro"];
const typologies = ["T0", "T1", "T2", "T3", "T4", "T5+"];
const conditions = ["Novo", "Como novo", "Usado, em bom estado", "A precisar de obras"];

export default function ValuationForm() {
  const [form, setForm] = useState({
    name: "", email: "", phone: "",
    address: "", zone: "", property_type: "", typology: "", area: "", condition: "", message: "",
  });
  const [submitting, setSubmitting] = useState(false);
  const navigate = useNavigate();

  const onChange = (e) => setForm((f) => ({ ...f, [e.target.name]: e.target.value }));

  const onSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      await api.post("/leads", { ...form, lead_type: "avaliacao" });
      setForm({ name: "", email: "", phone: "", address: "", zone: "", property_type: "", typology: "", area: "", condition: "", message: "" });
      navigate("/obrigado?type=avaliacao");
    } catch (err) {
      toast.error(formatApiErrorDetail(err?.response?.data?.detail) || "Não foi possível enviar.");
      setSubmitting(false);
    }
  };

  const inputCls = "w-full rounded-lg border border-stone-200 bg-white px-4 py-3 text-sm text-stone-900 focus:outline-none focus:ring-2 focus:ring-[#103C4A]/30";
  const labelCls = "block text-xs uppercase tracking-widest text-stone-500 mb-2";

  return (
    <form onSubmit={onSubmit} data-testid="valuation-form" className="space-y-5">
      <div className="grid md:grid-cols-2 gap-4">
        <div><label className={labelCls}>Nome</label><input required name="name" value={form.name} onChange={onChange} data-testid="valuation-name" className={inputCls} /></div>
        <div><label className={labelCls}>Email</label><input required type="email" name="email" value={form.email} onChange={onChange} data-testid="valuation-email" className={inputCls} /></div>
      </div>
      <div className="grid md:grid-cols-2 gap-4">
        <div><label className={labelCls}>Telefone</label><input name="phone" value={form.phone} onChange={onChange} data-testid="valuation-phone" className={inputCls} placeholder="+351" /></div>
        <div><label className={labelCls}>Localidade / zona</label><input name="zone" value={form.zone} onChange={onChange} data-testid="valuation-zone" className={inputCls} placeholder="Ex: Foz, Maia, Ermesinde..." /></div>
      </div>
      <div><label className={labelCls}>Morada do imóvel</label><input name="address" value={form.address} onChange={onChange} data-testid="valuation-address" className={inputCls} /></div>
      <div className="grid md:grid-cols-3 gap-4">
        <div>
          <label className={labelCls}>Tipo</label>
          <select name="property_type" value={form.property_type} onChange={onChange} data-testid="valuation-type" className={inputCls}>
            <option value="">Escolher...</option>
            {propertyTypes.map((t) => <option key={t} value={t}>{t}</option>)}
          </select>
        </div>
        <div>
          <label className={labelCls}>Tipologia</label>
          <select name="typology" value={form.typology} onChange={onChange} data-testid="valuation-typology" className={inputCls}>
            <option value="">Escolher...</option>
            {typologies.map((t) => <option key={t} value={t}>{t}</option>)}
          </select>
        </div>
        <div><label className={labelCls}>Área (m²)</label><input name="area" value={form.area} onChange={onChange} data-testid="valuation-area" className={inputCls} placeholder="Ex: 120" /></div>
      </div>
      <div>
        <label className={labelCls}>Estado</label>
        <select name="condition" value={form.condition} onChange={onChange} data-testid="valuation-condition" className={inputCls}>
          <option value="">Escolher...</option>
          {conditions.map((c) => <option key={c} value={c}>{c}</option>)}
        </select>
      </div>
      <div>
        <label className={labelCls}>Notas adicionais</label>
        <textarea name="message" rows={4} value={form.message} onChange={onChange} data-testid="valuation-message" className={inputCls} />
      </div>
      <button type="submit" disabled={submitting} data-testid="valuation-submit" className="btn-primary">
        {submitting ? "A enviar..." : "Pedir avaliação gratuita"}
      </button>
      <p className="text-xs text-stone-500">Os seus dados são tratados de forma confidencial e não são partilhados com terceiros.</p>
    </form>
  );
}
